import type { PaginationApi } from '@ingenico/api-sdk-device-management-public';

export enum ResourceIconCategoryFront {
  DEFAULT = 'DEFAULT',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  AUDIO = 'AUDIO',
  PACKAGE = 'PACKAGE',
}

export interface ResourceListItemFront {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly filename: string;
  readonly organizationName: string;
  readonly organizationId: string;
  readonly extension: string;
  readonly mimeType: string;
  readonly creationDate?: Date | string;
  readonly createdBy: string;
  readonly sizeBytes: number;
  readonly iconCategory: ResourceIconCategoryFront;
}

export interface PaginatedResourceList {
  readonly pagination: PaginationApi;
  readonly data: ResourceListItemFront[];
}

export interface ResourceArtifactCapabilitiesFront {
  readonly fileExtensions: string[];
  readonly maxFileSize: number;
  readonly unitFileSize: 'Bytes' | 'KB' | 'MB' | 'GB';
}

export const RESOURCE_ARTIFACT_DEFAULT_CAPABILITIES: ResourceArtifactCapabilitiesFront = {
  fileExtensions: ['.json'],
  // Preserve the existing fallback byte limit when no valid capability is available.
  maxFileSize: 10_000_000,
  unitFileSize: 'Bytes',
};
